import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, RouterOutlet, RouterLink } from "@angular/router";
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterLink,
    RouterOutlet
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})

export class LoginComponent {
  loginForm = new FormGroup({
    userName: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$^+=!*()@%&]).{8,}$'))]),
    });
  errorMessage: string ='';
  constructor(private authService: AuthService, private router: Router, private formBuilder: FormBuilder) {
  }

  login(loginData: any) {
    this.errorMessage = "";
    this.authService.login(loginData.userName, loginData.password).subscribe(
      (data: any) => {
        switch (data.tfa) {
          case "tfa": {
            this.router.navigate(['tfa'], { queryParams: { user: loginData.userName }});
            break;
          }
          default: {
            sessionStorage.setItem('token', JSON.stringify(data));
            sessionStorage.setItem('user', loginData.userName);
            this.authService.isInRole('Admin').subscribe(data => {
              if (data == true) {
                this.router.navigate(['Admin']);
              }
              else {
                this.router.navigate(['']);
              }
            });
            break;
          }
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.errorMessage = error.error.error_description;
      });
  }
}
